import apiService from '../apiService';

/**
 * 獲取管理員列表
 * @param {Object} params - 查詢參數
 * @param {number} params.page - 頁碼
 * @param {number} params.per_page - 每頁筆數
 * @param {string} params.search - 搜尋關鍵字
 * @returns {Promise} API 響應
 */
export const getManagers = async (params = {}) => {
    const url = '/api/admin/managers';
    return apiService.GET(url, params);
};

/**
 * 獲取單一管理員詳情
 * @param {number} managerId - 管理員 ID
 * @returns {Promise} API 響應
 */
export const getManagerDetail = async (managerId) => {
    const url = `/api/admin/managers/${managerId}`;
    return apiService.GET(url);
};

/**
 * 更新管理員資料
 * @param {number} managerId - 管理員 ID
 * @param {Object} data - 要更新的資料
 * @returns {Promise} API 響應
 */
export const updateManager = async (managerId, data) => {
    const url = `/api/admin/manager/${managerId}`;
    return apiService.PUT(url, data);
};

/**
 * 刪除管理員
 * @param {number} managerId - 管理員 ID
 * @returns {Promise} API 響應
 */
export const deleteManager = async (managerId) => {
    const url = `/api/admin/managers/${managerId}`;
    return apiService.DELETE(url);
};

/**
 * 創建管理員（註冊）
 * @param {Object} data - 管理員資料
 * @param {string} data.name - 名稱
 * @param {string} data.email - 電子郵件
 * @param {string} data.password - 密碼
 * @returns {Promise} API 響應
 */
export const createManager = async (data) => {
    const url = '/api/admin/signup';
    return apiService.POST(url, data);
};
